import { getTransactions } from "../../js/api/profile.js";
import {generateView} from "../templates/currentbalance.js";
import { getagents } from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = '';
let today = new Date();
let dd = String(today.getDate()).padStart(2, '0');
let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
let yyyy = today.getFullYear();

today = yyyy + '-' + mm + '-' + dd;

let startDate = today;
let endDate = today;

let CurrentBalance = {
  render: async () => {

    role = localStorage.getItem("role");
        let profileName = localStorage.getItem("name");

        let userCoins = [];
        let userCoinsView = ``;

        if (localStorage.getItem('coins')) {
            userCoins = JSON.parse(localStorage.getItem('coins'));

            userCoins.forEach(coin => {
                userCoinsView += `<option value="${coin.id}">${_t('Monedha')}: ${Utils.currencyCode(coin.currency)}</option>`;
            });
        }

        let agents = await getagents(startDate, endDate, userCoins[0]);
        let agentsView = "";
    
        if (agents && agents.children_users.length !== 0) {
            const allIds = agents.children_users.map(a => a.id);
            const uniqueIds = [...new Set(allIds)];
            uniqueIds.forEach((agentId) => {
                const agent = agents.children_users.find(a => a.id === agentId);
                agentsView += `<option value="${agent.id}">${agent.username}</option>`;
            });
        }
       
        let transactions = await getTransactions(startDate, endDate, userCoins.length > 0 ? userCoins[0].id: "");
        let transactionView = await generateView(transactions);


        let view = /*html*/ `
                <div class="currentUserWrapper">
                     <a class="backBtn">
                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                     </a>
                     <span>${_t('Current Balance')} - ${profileName}</span>
               </div>

                <div class="newMyBetsFilter">
                    <input type="text" readonly  class="form-control" id="myCalendar">
                    <button type="button" class="btn-filter">${_t('Filtro')}</button>
                </div>


                <div class="my-bets-select-filters border-top">
                    <select name="accountCoinSelect" id="currentBalanceCoinSelect" placeholder="${_t('Monedha')}">
                        ${userCoinsView}
                    </select>
                    <select name="accountAgentSelect" id="accountAgentSelect" class="${role == "User" ? "hidden" : ""}">
                      <option value="">${_t('Zgjidh perdorues')}</option>
                      ${agentsView}
                    </select>
                </div>

               <div class="currentUserContent m-t-6">
                   <div id="tblCurrentBalance">
                   ${transactionView}
                    </div>
                   <div class="currentUserRows m-t-6">
                       <div class="currentUserRow">
                           <span>${_t('Total Receipts/Paments')}</span>
                           <span id="totalCurrentBalance">0</span>
                       </div>
                       <div class="currentUserRow">
                           <span>${_t('Total Commission')}</span>
                           <span>0</span>
                       </div>
                       <div class="currentUserRow">
                           <span>${_t('Total Bets')}</span>
                           <span>0</span>
                       </div>
                   </div>
                </div>
           `;
        return view;
  },
  after_render: async () => {
    
    $('body').on('change', '#currentBalanceCoinSelect', async function(e) {
        e.preventDefault()
        e.stopPropagation();
        e.stopImmediatePropagation();
        const transactions = await getTransactions(startDate, endDate, $('#currentBalanceCoinSelect').val());

        console.log(transactions);

        let littleView  = await generateView(transactions);

        $('body #tblCurrentBalance *').remove();
        $('body #tblCurrentBalance').append(littleView );

        let totalBalance = 0;
        $('body .currentBalanceAmount').each(function(){
            totalBalance += parseFloat($(this).text().replace(/,/g, ''));
        });
        $('body #totalCurrentBalance').text(Utils.formatNumber(totalBalance));
        $('body .loaderWrapper').remove();

        if( parseFloat($('body #totalCurrentBalance').text()) > 0 ) {
            $('body #totalCurrentBalance').addClass('green')
        };
      });

      let totalBalance = 0;
      $('body .currentBalanceAmount').each(function(){
          totalBalance += parseFloat($(this).text().replace(/,/g, ''));
      });
      $('body #totalCurrentBalance').text(Utils.formatNumber(totalBalance));
      
    $("#myCalendar").daterangepicker(
      {
        alwaysShowCalendars: false,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false,
        opens: "center",
        locale: {
          applyLabel: _t('Apliko'),
          cancelLabel: _t('Anulo')
        }
      },
      async function (start, end, label) {
        $("#contentLoader").append(
          '<div class="loaderWrapper"><div class="loader"></div></div>'
        );
        startDate = start.format("YYYY-MM-DD");
        endDate = end.format("YYYY-MM-DD");

        renderBalance();
      }
    );

    $("body").on("change", "#accountAgentSelect", async function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
  
        renderBalance();
  
        $("body #accountBalanceTbl *").remove();
      });

    startDate = moment().startOf("day").format('YYYY-MM-DD');
    endDate = moment().endOf("day").format('YYYY-MM-DD');
    
    renderBalance();
  },
};

async function renderBalance() {
  const transactions = await getTransactions(
    startDate,
    endDate,
    $("#currentBalanceCoinSelect").val(),
    $("#accountAgentSelect").val()
  );

  console.log(transactions);

  let littleView = await generateView(transactions);

  $("body #tblCurrentBalance *").remove();
  $("body #tblCurrentBalance").append(littleView);

  let totalBalance = 0;
  $("body .currentBalanceAmount").each(function () {
    totalBalance += parseFloat($(this).text().replace(/,/g, ''));
  });
  $("body #totalCurrentBalance").text(Utils.formatNumber(totalBalance));
  $("body .loaderWrapper").remove();

  if (parseFloat($("body #totalCurrentBalance").text()) > 0) {
    $("body #totalCurrentBalance").addClass("green");
  }
}

export default CurrentBalance;
